<template>
  <div class="notice-view">
    <!-- NoticeView.vue -->

    <NoticeTable
      :page-param-base="0"
      :extra-query="{}"
      :notices="paginatedNotices"
      :all-notices="normalizedAllNotices"

      :current-page="currentPage"
      :per-page="perPage"
      :total="nonPinnedTotal"
    />

    <Pagination
      :total="nonPinnedTotal"
      :current-page="currentPage"
      :page="currentPage"
      :page-size="perPage"
      @change="changePage"
    />

    <SearchBar @search="handleSearch" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import SearchBar from "@/components/SearchBar.vue";
import NoticeTable from "@/components/NoticeTable.vue";
import Pagination from "@/components/Pagination.vue";
import axios from '@/utils/axios';

const notices = ref([]);         // 원본(공지 포함)
const keyword = ref("");
const selectedField = ref("title");  // 검색 필드
const currentPage = ref(1);
const perPage = 5;

onMounted(() => {
  getAllNotice();
});

const getAllNotice = () => {
  axios.get("/bx201/notice")
    .then((response) => {
      // response.data: [{ id, title, content, top_fixed, createdAt, ... }]
      notices.value = response.data;
    })
    .catch(() => { /* 에러 처리 필요시 추가 */ });
};

/** 1) 검색/필터 (공지 포함) */
const filteredNotices = computed(() => {
  const list = notices.value || [];
  if (!keyword.value) return list;
  const k = keyword.value.toLowerCase();
  if (selectedField.value === "title") {
    return list.filter(n => String(n.title ?? "").toLowerCase().includes(k));
  } else if (selectedField.value === "content") {
    return list.filter(n => String(n.content ?? "").toLowerCase().includes(k));
  }
  return list;
});

/** 2) NoticeTable 호환을 위해 top_fixed → topFixed 로 정규화 */
const normalizedAllNotices = computed(() =>
  (filteredNotices.value || []).map(n => ({
    ...n,
    topFixed: n.top_fixed === true || n.topFixed === true, // 둘 다 케이스 대응
  }))
);

/** 3) 일반글(공지 제외) 정렬/총합 */
const nonPinnedSorted = computed(() =>
  normalizedAllNotices.value
    .filter(n => !n.topFixed)
    .sort((a, b) => Number(b.id ?? 0) - Number(a.id ?? 0)) // 최신 id 우선
);

const nonPinnedTotal = computed(() => nonPinnedSorted.value.length);

/** 4) 현재 페이지용 일반글 조각 (perPage 유지) */
const paginatedNotices = computed(() => {
  const start = (currentPage.value - 1) * perPage;
  return nonPinnedSorted.value.slice(start, start + perPage);
});

/** 검색 이벤트 */
const handleSearch = (term) => {
  keyword.value = term.keyword;
  selectedField.value = term.field;
  currentPage.value = 1; // 검색 시 첫 페이지로
};

/** 페이지 변경 */
const changePage = (page) => {
  currentPage.value = page;
};
</script>

<style scoped>
.notice-view {
  padding: 80px 16px;
  max-width: 1000px;
  margin: 0 auto;
}
</style>
